import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "titulo m-0" }, "Log Produtos", -1)
const _hoisted_4 = { class: "legenda" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-arrow-left"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Voltar", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  class: "col-12 d-flex flex-column justify-content-between align-items-center p-0 overflow-hidden",
  style: {"border-radius":"14px"}
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex w-100 p-4 gap-2\" style=\"background:#203972;\"><p class=\"titulo m-0 text-white\" style=\"width:13rem;\">N°</p><p class=\"titulo m-0 text-white\" style=\"width:20rem;\">Automocao</p><p class=\"titulo m-0 text-white\" style=\"width:100%;\">Loja</p><p class=\"titulo m-0 text-white\" style=\"width:20rem;\">Atualizados</p><p class=\"titulo m-0 text-white\" style=\"width:20rem;\">Erros</p><p class=\"titulo m-0 text-white\" style=\"width:23rem;\">Data</p></div>", 1)
const _hoisted_11 = { class: "d-flex w-100 flex-column bg-white" }
const _hoisted_12 = {
  key: 0,
  class: "w-100 d-flex justify-content-center align-items-center p-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Nenhum dado foi encontrado", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  style: {"white-space":"nowrap","width":"23rem"},
  class: "texto bold cor_texto_1 d-inline-block text-trunate m-0"
}
const _hoisted_23 = {
  class: "col-12 d-flex justify-content-center align-items-center p-3",
  id: "load"
}
const _hoisted_24 = {
  key: 0,
  style: {"color":"#dc3545"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}
const _hoisted_28 = {
  key: 2,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_ModalLogProduto = _resolveComponent("ModalLogProduto")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.arrayLog.length) + " resultados", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back())),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_8)
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (!_ctx.loadLog && _ctx.arrayLog.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true),
        (_ctx.skeleton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 15,
                class: "text-center p-5 d-block"
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayLog, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            onClick: ($event: any) => (_ctx.abreModal(item)),
            class: "d-flex p-5 gap-2 cursor-pointer",
            style: _normalizeStyle(i%2 == 0 ? 'background: white !important;' : 'background: #f9f9f9 !important;')
          }, [
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"13rem"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.id
            }, _toDisplayString(item.id), 9, _hoisted_17),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"20rem"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.automocao
            }, _toDisplayString(item.automocao), 9, _hoisted_18),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"100%"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.loja
            }, _toDisplayString(item.loja), 9, _hoisted_19),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"20rem"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.qtd_atualizados
            }, _toDisplayString(item.qtd_atualizados), 9, _hoisted_20),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"20rem"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.qtd_erros
            }, _toDisplayString(item.qtd_erros), 9, _hoisted_21),
            _createElementVNode("p", _hoisted_22, _toDisplayString(new Date(item.updated_at).toLocaleDateString("pt-BR")) + " " + _toDisplayString(new Date(item.updated_at).toLocaleString("pt-BR", { hour: "numeric", minute: "numeric", hour12: false, })), 1)
          ], 12, _hoisted_16))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscaLogPaginado(_ctx.pagina ? _ctx.pagina + 1 : 1))),
        style: {"width":"15rem","height":"3.2rem"},
        id: "loadLogButton",
        class: "card d-none flex-row gap-2 justify-content-center align-items-center cursor-pointer"
      }, [
        (_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
          : _createCommentVNode("", true),
        (_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Carregando mais"))
          : _createCommentVNode("", true),
        (!_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Carregar mais"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalLogProduto, {
      fechaModal: _ctx.fechaModal,
      log: _ctx.logSelecionado
    }, null, 8, ["fechaModal", "log"])
  ]))
}